<template>
    <div class="w-full p-4 bg-white rounded shadow   flex flex-col gap-4">
        <div class="flex gap-6">
            <!-- Adicionar novo Access Profile -->
            <div class="flex-1">
                <label class="block font-semibold mb-1">Access Profiles disponíveis</label>
                <div class="flex items-center gap-2">
                    <input v-model="newAccessProfile" type="number" class="border rounded p-1 w-24" placeholder="ID" />
                    <button @click="addAccessProfile" class="bg-primary text-white px-2 py-1 rounded">Adicionar</button>
                </div>
                <div class="mt-2 text-sm text-gray-700">Atuais: {{ availableAccessProfiles.join(', ') }}</div>
            </div>

            <!-- Adicionar novo Organizational Structure -->
            <div class="flex-1">
                <label class="block font-semibold mb-1">Organizational Structures disponíveis</label>
                <div class="flex items-center gap-2">
                    <input v-model="newOrgStructure" type="number" class="border rounded p-1 w-24" placeholder="ID" />
                    <button @click="addOrgStructure" class="bg-primary text-white px-2 py-1 rounded">Adicionar</button>
                </div>
                <div class="mt-2 text-sm text-gray-700">Atuais: {{ availableOrganizationalStructures.join(', ') }}</div>
            </div>
        </div>

        <!-- Filtros -->
        <div class="flex gap-4 flex-wrap">
            <input v-model="filters.nome" placeholder="Nome" class="border p-2 rounded w-48" />
            <input v-model="filters.setor" placeholder="Setor" class="border p-2 rounded w-48" />
            <input v-model="filters.pdv" placeholder="PDV" class="border p-2 rounded w-48" />
            <input v-model="filters.lote" placeholder="Lote" class="border p-2 rounded w-48" />
            <input v-model="filters.dia" placeholder="Dia" class="border p-2 rounded w-48" />
        </div>

        <!-- Lista de Produtos -->
        <table class="table-auto border mt-4">
            <thead>
                <tr class="bg-gray-100 text-left">
                    <th class="border px-4 py-2">ID</th>
                    <th class="border px-4 py-2">Detalhes</th>
                    <th class="border px-4 py-2">Access Profile</th>
                    <th class="border px-4 py-2">Organizational Structure</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in filteredProducts" :key="product.id" class="hover:bg-gray-50">
                    <td class="border px-4 py-2">{{ product.id }}</td>
                    <td class="border px-4 py-2">{{ product.detalhes }}</td>
                    <td class="border px-4 py-2">
                        <select v-model="accessProfileSelection[product.id]" @change="updateAccessProfile(product.id)"
                            class="border rounded p-1">
                            <option value="">--</option>
                            <option v-for="id in availableAccessProfiles" :key="id" :value="id">{{ id }}</option>
                        </select>
                    </td>
                    <td class="border px-4 py-2">
                        <select v-model="organizationalStructureSelection[product.id]"
                            @change="updateOrgStructure(product.id)" class="border rounded p-1">
                            <option value="">--</option>
                            <option v-for="id in availableOrganizationalStructures" :key="id" :value="id">{{ id }}
                            </option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Alerter -->
        <div v-if="unmappedProducts.length" class="mt-4 text-yellow-600 font-medium">
            Atenção: {{ unmappedProducts.length }} produtos não estão totalmente vinculados.
        </div>

        <!-- JSON de saída -->
        <div class="mt-6 flex flex-col">
            <label class="block font-semibold mb-1">Resultado JSON:</label>
            <pre class="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-60 w-full ">
        {{ JSON.stringify(modelValue, null, 2) }}
      </pre>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, toRefs, defineProps, defineEmits, inject } from 'vue'

const props = defineProps({
    products: Array,
    modelValue: Object
})
const emit = defineEmits(['update:modelValue'])
const { modelValue } = toRefs(props)

const filters = ref({
    nome: '',
    setor: '',
    pdv: '',
    lote: '',
    dia: ''
})



const accessProfileMap = ref({})
const orgStructureMap = ref({})
const accessProfileSelection = ref({})
const organizationalStructureSelection = ref({})
const availableAccessProfiles = ref([])
const availableOrganizationalStructures = ref([])

const newAccessProfile = ref('')
const newOrgStructure = ref('')
const alert = inject("alert");
// Emite novo valor
function emitValue() {
    emit('update:modelValue', {
        accessProfile: accessProfileMap.value,
        organizationalStructure: orgStructureMap.value
    })
}


// Adiciona Access Profile
function addAccessProfile() {
    const id = parseInt(newAccessProfile.value)
    if (!id || availableAccessProfiles.value.includes(id)) return
    availableAccessProfiles.value.push(id)
    newAccessProfile.value = ''
}

// Adiciona Org Structure
function addOrgStructure() {
    const id = parseInt(newOrgStructure.value)
    if (!id || availableOrganizationalStructures.value.includes(id)) return
    availableOrganizationalStructures.value.push(id)
    newOrgStructure.value = ''
}

// Atualiza Access Profile
function updateAccessProfile(productId) {
    const selectedId = accessProfileSelection.value[productId]
    for (const id in accessProfileMap.value) {
        accessProfileMap.value[id] = accessProfileMap.value[id].filter(p => p !== productId)
    }
    if (selectedId) {
        if (!accessProfileMap.value[selectedId]) accessProfileMap.value[selectedId] = []
        accessProfileMap.value[selectedId].push(productId)
    }
    emitValue()
}

// Atualiza Org Structure
function updateOrgStructure(productId) {
    const selectedId = organizationalStructureSelection.value[productId]
    for (const key in orgStructureMap.value) {
        if (orgStructureMap.value[key] === productId) {
            delete orgStructureMap.value[key]
        }
    }

    if (orgStructureMap.value[selectedId] && orgStructureMap.value[selectedId] !== productId) {
        alert.open('Atenção', `A Estrutura Organizacional ${orgStructureMap.value[selectedId]} já está vinculado a outro produto.`, 'warning')
        organizationalStructureSelection.value[productId] = ''
        emitValue()
        return
    }

    if (selectedId) {
        orgStructureMap.value[selectedId] = productId
    }
    emitValue()
}


// Produtos filtrados
const filteredProducts = computed(() => {
    return props.products.filter(p =>
        (!filters.value.nome || p.nome?.toLowerCase().includes(filters.value.nome.toLowerCase())) &&
        (!filters.value.setor || p.setor?.toLowerCase().includes(filters.value.setor.toLowerCase())) &&
        (!filters.value.pdv || p.pdv?.toLowerCase().includes(filters.value.pdv.toLowerCase())) &&
        (!filters.value.lote || p.lote?.toLowerCase().includes(filters.value.lote.toLowerCase())) &&
        (!filters.value.dia || p.dia?.toLowerCase().includes(filters.value.dia.toLowerCase()))
    )
})

// Produtos que faltam mapeamento
const unmappedProducts = computed(() => {
    return props.products.filter(p => {
        const inAccess = Object.values(accessProfileMap.value).some(arr => arr.includes(p.id))
        const inOrg = Object.values(orgStructureMap.value).includes(p.id)
        return !inAccess || !inOrg
    })
})

// Inicializa watchers para hidratar dados
watch(modelValue, (newVal) => {
    accessProfileMap.value = { ...(newVal.accessProfile || {}) }
    orgStructureMap.value = { ...(newVal.organizationalStructure || {}) }

    const profiles = Object.keys(accessProfileMap.value).map(Number)
    const structures = Object.keys(orgStructureMap.value).map(Number)

    availableAccessProfiles.value = Array.from(new Set([...availableAccessProfiles.value, ...profiles]))
    availableOrganizationalStructures.value = Array.from(new Set([...availableOrganizationalStructures.value, ...structures]))

    // Popular seleções
    accessProfileSelection.value = {}
    for (const id in accessProfileMap.value) {
        accessProfileMap.value[id].forEach(pid => accessProfileSelection.value[pid] = parseInt(id))
    }
    organizationalStructureSelection.value = {}
    for (const id in orgStructureMap.value) {
        const pid = orgStructureMap.value[id]
        organizationalStructureSelection.value[pid] = parseInt(id)
    }
}, { immediate: true })
</script>
